<template>
    <div class="container remove-padding-margin">
        <div id="loadingPageImportLayanan">
            <div class="fullpageLoading">
                <div class="d-block">
                    <center>
                        <span class="spinner-border spinner-border-sm-loader" role="status" aria-hidden="true"></span>
                        <h4 style="margin-top:15px"><span class="count" id="dataCOunterLayanan">0</span>%</h4>
                        <h5>Proses impor..</h5>
                    </center>
                </div>
            </div>
        </div>
        <div v-if="ekspor.onprogress == 1">
            <div class="fullpageLoading">
                <div class="d-block">
                    <center>
                        <span
                            class="spinner-border spinner-border-sm-loader m-0"
                            role="status"
                            aria-hidden="true"
                        ></span>
                        <h5 style="margin-top:15px">
                            Mohon tunggu, sedang mengekspor {{ ekspor.progress_looping }} dari {{ ekspor.lenght }} Data
                        </h5>
                        <div>
                            <a :href="ekspor.exportlink" v-if="ekspor.exportlink !== ''" ref="eksporlink"
                                >Download File Ekspor Disini</a
                            >
                        </div>
                    </center>
                </div>
            </div>
        </div>

        <div id="loadingPageExportLayanan">
            <div class="fullpageLoading">
                <div class="d-block">
                    <center>
                        <span
                            class="spinner-border spinner-border-sm-loader m-0"
                            role="status"
                            aria-hidden="true"
                        ></span>
                        <h5 style="margin-top:15px">Proses ekspor..</h5>
                    </center>
                </div>
            </div>
        </div>
        <div id="listlayanan">
            <div class="header-top bg-white">
                <div class="row justify-content-center align-items-center set-row showPageDefault w-limit">
                    <div class="col-md-2 col-sm-2 col-2 remove-padding">
                        <img @click="back" src="../../assets/gambar/back-blue.svg" alt="" />
                    </div>
                    <div class="col-md-8 col-sm-8 col-8 text-center remove-padding">
                        <h6 class="remove-margin font-16 font-colorcheck text-promo nomore">Daftar Layanan</h6>
                    </div>
                    <div class="col-md-2 col-sm-2 col-2 remove-padding">
                        <img
                            class="imageSearch"
                            src="../../assets/icons/search.svg"
                            @click="showsearch"
                            alt=""
                            id="iconsearch"
                        />
                    </div>
                </div>
                <div class="row justify-content-center align-items-center set-row showPageSearch">
                    <div class="col-md-9 col-sm-9 col-9 remove-padding">
                        <input
                            class="inputSearch"
                            id="input_search_Layanan"
                            type="text"
                            v-on:keyup="searchDeposit"
                            v-model="searchKey"
                            placeholder="Cari.."
                        />
                    </div>
                    <div class="col-md-3 col-sm-3 col-3 remove-padding">
                        <img class="imageSearch" v-on:click="closesearch" src="../../assets/img/x2.svg" alt="" />
                    </div>
                </div>
            </div>
            <main class="add-padding-default bg-gray w-limit" style="margin-top: 50px; height: calc(100%-50px)">
                <div class="bg-yellow p-x-20 p-y-8 d-flex" style="margin: 0 -20px">

                    <img src="@/assets/icons/alert-circle-yellow.svg" alt="" class="m-r-12" />
                    <div class="d-block">
                        <div class="f-semi f-c-black f-14">
                            Template Data Layanan telah diperbarui pada tanggal 24 April 2021.
                        </div>
                        <div class="f-regular f-c-midgrey f-12">
                            Pastikan Anda menggunakan template terbaru sebelum meng-unggah data untuk di import.
                        </div>
                    </div>
                </div>

                <div class="flex-100 showPageSearch">
                    <div class="flex-1" v-if="leght_data >= 0">
                        <div class="Search-BOX mar-top-60 mar-bottom-16" id="textTop"></div>
                        <div class="">
                            <div class="row set-card" v-for="ls in layanansearch" :key="ls.idlayanan">
                                <div class="col-md-10 col-sm-10 col-10 text-left remove-padding">
                                    <div class="nomore">
                                        <b v-html="searchHighlight(ls.nama_layanan, searchKey)"></b>
                                    </div>
                                    <div class="f-c-midgrey f-13 f-regular">
                                        <div>
                                            <img src="../../assets/icons/clock.svg" alt="" class="m-r-4" />
                                            <span v-if="ls.durasi_penyelesaian_hari"
                                                >{{ ls.durasi_penyelesaian_hari }} Hari</span
                                            >
                                            <span v-if="ls.durasi_penyelesaian_jam"
                                                >{{ ls.durasi_penyelesaian_jam }} Jam</span
                                            >
                                        </div>
                                        <div v-if="ls.mesin.use_snapbrige">
                                            <img src="../../assets/icons/mesin.svg" alt="" class="m-r-4" /> Mesin
                                            Snapbridge
                                            {{ ls.mesin.mesin_use }}
                                        </div>
                                        <div v-if="ls.min_depo <= 0 && ls.min_reg <= 0">
                                            <img src="../../assets/icons/disc.svg" alt="" class="m-r-4" /> Tanpa minimal
                                            order
                                        </div>
                                        <div v-if="ls.min_reg">
                                            <img src="../../assets/icons/disc.svg" alt="" class="m-r-4" /> Minimal
                                            {{ ls.min_reg }} {{ ls.satuan }} (Reguler)
                                        </div>
                                        <div v-if="ls.min_depo > 0">
                                            <img src="../../assets/icons/disc.svg" alt="" class="m-r-4" /> Minimal
                                            {{ ls.min_depo }} {{ ls.satuan }} (Deposit)
                                        </div>
                                    </div>
                                    <div class="color-206CF d-flex-between-center">
                                        <div>
                                          <img src="../../assets/icons/tag1.svg" alt="" /> Rp. {{ ls.harga }} /
                                          {{ ls.satuan }}
                                        </div>
                                        <div class="info-snap f-12 f-c-midgrey f-regular bg-grey" v-if="ls.mesin.use_snapbrige">
                                            Snapbridge
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="col-md-2 col-sm-2 col-2 text-right remove-padding dropdown"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    <img src="@/assets/icons/more-horizontal2.svg" alt="" />
                                    <div class="dropdown-menu garis-deposit" aria-labelledby="dropdownMenuLink">
                                        <a class="dropdown-item icon-1" href="#" @click="edits(ls.idlayanan)" v-if="validateAccess('regularServices.update')"
                                            ><span class="mar-right-10"><i class="far fa-edit color-206CF"></i></span
                                            >Ubah</a
                                        >
                                        <a class="dropdown-item icon-2" href="#" @click="showmodaldels(ls)" v-if="validateAccess('regularServices.delete')"
                                            ><span class="mar-right-10"
                                                ><img src="@/assets/icons/trash-red-big.svg"/></span
                                            >Hapus</a
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="loadmoreSpinner" id="loadingSpinnerLayananSearch" style="display: none">
                                <center>
                                    <div class="sp sp-circle"></div>
                                </center>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex-100 showPageDefault">
                    <div class="flex-1" v-if="this.leght_data === 0">
                        <div class="image text-alignC">
                            <img class="img-fluid" src="../../assets/icons/Hanger.svg" alt="" />
                            <h5 class="text-center">Belum ada layanan yang terdaftar</h5>
                            <h6 class="text-center">Silahkan klik tombol + untuk menambahkan</h6>
                        </div>
                    </div>
                    <div class="flex-1" v-else>
                        <div class="card-2">
                            <div>Total {{ leght_data }} Layanan</div>
                            <FilterSorting @filter="filter" :jenisFilter="'layanan'" :sortByColumn="'nama_layanan'" />
                            <br />
                            <div class="row set-card" v-for="l in layanan" :key="l.idlayanan">
                                <div class="col-md-10 col-sm-10 col-10 text-left remove-padding">
                                    <div class="nomore">
                                        <b> {{ l.nama_layanan }}</b>
                                    </div>
                                    <div class="f-c-midgrey f-13 f-regular">
                                        <div>
                                            <img src="../../assets/icons/clock.svg" alt="" class="m-r-4" />
                                            <span v-if="l.durasi_penyelesaian_hari"
                                                >{{ l.durasi_penyelesaian_hari }} Hari</span
                                            >
                                            <span v-if="l.durasi_penyelesaian_jam"
                                                >{{ l.durasi_penyelesaian_jam }} Jam</span
                                            >
                                        </div>
                                        <div v-if="l.mesin.use_snapbrige">
                                            <img src="../../assets/icons/mesin.svg" alt="" class="m-r-4" /> Mesin
                                            Snapbridge
                                            {{ l.mesin.mesin_use }}
                                        </div>
                                        <div v-if="l.min_depo <= 0 && l.min_reg <= 0">
                                            <img src="../../assets/icons/disc.svg" alt="" class="m-r-4" /> Tanpa minimal
                                            order
                                        </div>
                                        <div v-if="l.min_reg">
                                            <img src="../../assets/icons/disc.svg" alt="" class="m-r-4" /> Minimal
                                            {{ l.min_reg }} {{ l.satuan }} (Reguler)
                                        </div>
                                        <div v-if="l.min_depo > 0">
                                            <img src="../../assets/icons/disc.svg" alt="" class="m-r-4" /> Minimal
                                            {{ l.min_depo }} {{ l.satuan }} (Deposit)
                                        </div>
                                    </div>
                                    <div class="color-206CF d-flex-between-center">
                                        <div>
                                          <img src="../../assets/icons/tag1.svg" alt="" /> Rp. {{ l.harga }} /
                                          {{ l.satuan }}
                                        </div>
                                        <div class="info-snap f-12 f-c-midgrey f-regular bg-grey" v-if="l.mesin.use_snapbrige">
                                            Snapbridge
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="col-md-2 col-sm-2 col-2 text-right remove-padding dropdown"
                                    :id="'dropdownMenuLinklist' + l.idlayanan"
                                    :data-toggle="(validateAccess('regularServices.update') || validateAccess('regularServices.update')) && 'dropdown'"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    <img src="../../assets/icons/more-horizontal2.svg" alt="" />
                                    <div class="dropdown-menu garis-deposit" aria-labelledby="dropdownMenuLinklist">
                                        <a class="dropdown-item icon-1" href="#" @click="edit(l.idlayanan)" v-if="validateAccess('regularServices.update')"
                                            ><span class="mar-right-10"><i class="far fa-edit color-206CF"></i></span
                                            >Ubah</a
                                        >
                                        <a class="dropdown-item icon-2" href="#" @click="showmodaldel(l)" v-if="validateAccess('regularServices.delete')"
                                            ><span class="mar-right-10"
                                                ><img src="../../assets/icons/trash-red-big.svg"/></span
                                            >Hapus</a
                                        >
                                    </div>
                                </div>
                            </div>
							<!-- deprecated DomSubtreeModifiedEvent
                            <div class="loadmoreSpinner" id="loadingSpinnerLayanan" style="display: none">
                                <center>
                                    <div class="sp sp-circle"></div>
                                </center>
                            </div> -->
							<SOLoadMoreLoading
                                id="loadMoreLayanan"
								:loading="(leght_data > 0) && (leght_data > layanan.length)"
								@intersect="!loadingMoreLayanan && loadMoreListLayanan()"
                            />
                        </div>
                    </div>
                    <div
                        class="flying-button-wrapper w-limit context-menu"
                        v-on:click.self="onDropdownHide"
                        @hide="onDropdownHide"
                    >
                        <div @hide="onDropdownHide" v-on:click.self="onDropdownHide" class="flying-inside dropup">
                            <a class="flying-button offanimation" data-toggle="dropdown" data-display="static"></a>
                            <div class="dropdown-menu" v-on:click.self="onDropdownHide" @hide="onDropdownHide">
                                <a class="dropdown-item tambah-layanan-onboarding offanimation" @click="tambahlayanan" v-if="validateAccess('regularServices.create')">
                                    <div
                                        class="icon-prefix"
                                        style="background-image: url('../../assets/icons/plus1.svg')"
                                    ></div>
                                    Tambahkan Layanan Baru
                                </a>
                                <a class="dropdown-item" data-toggle="modal" data-target="#impormodal">
                                    <div
                                        class="icon-prefix"
                                        style="background-image: url('../../assets/icons/upload.svg')"
                                    ></div>
                                    Impor Data Layanan
                                </a>
                                <a class="dropdown-item" href="#" @click="exportLayananBackground">
                                    <div
                                        class="icon-prefix"
                                        style="background-image: url('../../assets/icons/upload(1).svg')"
                                    ></div>
                                    Ekspor Data Layanan
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <div class="modal fade" id="impormodal" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content w-limit">
                        <div class="modal-header">
                            <div class="nav-btn kiri"></div>
                            <h5 class="navbar-title text-center">Impor Data Layanan</h5>
                            <div class="nav-btn kanan tutup">
                                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="" />
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="font-16 remove-padding-margin desciption-txt-modal">
                                File yang diupload harus berupa file excel dengan format penulisan sesuai dengan contoh
                                berikut:
                            </div>
                            <div class="div-impor mar-top-bot-15 color-206CF" @click="cekconnection">
                                <img class="" src="../../assets/icons/download.svg" alt="" /> Template Data Layanan
                            </div>
                            <div class="mar-bottom-16 desciption-txt-modal">
                                Jika sudah sesuai dengan template, silahkan upload file melalui kolom dibawah ini.
                            </div>
                            <div class="line-patah mar-bottom-20">
                                <div class="atribute" id="imagePreview">
                                    <label for="importLayanan">
                                        <img
                                            src="../../assets/icons/file-plus.svg"
                                            alt=""
                                            style="max-width: 70px"
                                            id="logo"
                                        />
                                        <div>Klik untuk upload...</div>
                                    </label>
                                    <input
                                        type="file"
                                        id="importLayanan"
                                        ref="file"
                                        v-on:change="importdata"
                                        accept=".xlsx"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="deletemodal" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content w-limit">
                        <div class="modal-header">
                            <div class="nav-btn kiri"></div>
                            <h5 class="navbar-title text-center">Hapus Layanan</h5>
                            <div class="nav-btn kanan tutup">
                                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="" />
                            </div>
                        </div>
                        <div class="modal-body">
                            <p class="font-16 remove-padding-margin">
                                Data yang dihapus tidak dapat dikembalikan. Apakah anda yakin ingin menghapus Layanan
                                <b>{{ namalayanan }}</b> ?
                            </p>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-outline-primary btn-long"
                                data-dismiss="modal"
                                @click="deletelayanan"
                            >
                                Hapus
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="errordeletemodal" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content w-limit">
                        <div class="modal-header">
                            <div class="nav-btn kiri"></div>
                            <h5 class="navbar-title text-center">Tidak Dapat Menghapus</h5>
                            <div class="nav-btn kanan tutup">
                                <img src="../../assets/img/x2.svg" @click="closeErrorModal" alt="" />
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="f-regular f-c-black f-16 m-d-8">Layanan tidak dapat dihapus, karena terhubung dengan paket deposit:</div>
                            <div>
                              <ul style="padding-left: 20px" class="m-d-0">
                                <li class="f-regular f-c-black f-16" v-for="paketDeposit, idx in listPaketDeposit" :key="`paketDP${idx}`">
                                  {{paketDeposit}}
                                </li>
                              </ul>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <div style="text-align:left" class="f-regular f-c-midgrey f-14" v-if="totalPaketDp > 4">
                              Serta {{totalPaketDp - 4}} paket lainnya...
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="modal-lewati-panduan" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content w-limit">
                        <div class="modal-header">
                            <div class="nav-btn kiri"></div>
                            <h5 class="navbar-title text-center">Batal Mengikuti Panduan</h5>
                            <div class="nav-btn kanan tutup"></div>
                        </div>
                        <div class="modal-body">
                            <p>
                                Anda sedang mengikuti panduan pengguna, batal mengikuti panduan akan menghentikan mode
                                panduan. Apakah Anda yakin ingin keluar dari panduan?
                            </p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary btn-long m-d-20" data-dismiss="modal">
                                Lanjutkan Panduan
                            </button>
                            <a @click="skipOnboarding(3)" class="m-t-20 f-semi f-12 f-c-blue"
                                >Saya Ingin Keluar Dari Mode Panduan</a
                            >
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="modal-lewati-panduan-karyawan" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content w-limit">
                        <div class="modal-header">
                            <div class="nav-btn kiri"></div>
                            <h5 class="navbar-title text-center">Batal Mengikuti Panduan</h5>
                            <div class="nav-btn kanan tutup"></div>
                        </div>
                        <div class="modal-body">
                            <p>
                                Anda sedang mengikuti panduan pengguna, batal mengikuti panduan akan menghentikan mode
                                panduan. Apakah Anda yakin ingin keluar dari panduan?
                            </p>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-outline-primary btn-long m-d-20"
                                @click="cekOnboardingLayanan"
                                data-dismiss="modal"
                            >
                                Lanjutkan Panduan
                            </button>
                            <a @click="skipOnboarding(3)" class="m-t-20 f-semi f-12 f-c-blue"
                                >Saya Ingin Keluar Dari Mode Panduan</a
                            >
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="modal-lewati-panduan-layanan" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content w-limit">
                        <div class="modal-header">
                            <div class="nav-btn kiri"></div>
                            <h5 class="navbar-title text-center">Batal Mengikuti Panduan</h5>
                            <div class="nav-btn kanan tutup"></div>
                        </div>
                        <div class="modal-body">
                            <p>
                                Anda sedang mengikuti panduan pengguna, batal mengikuti panduan akan menghentikan mode
                                panduan. Apakah Anda yakin ingin keluar dari panduan?
                            </p>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-outline-primary btn-long m-d-20"
                                @click="onboardingLayananContinue"
                                data-dismiss="modal"
                            >
                                Lanjutkan Panduan
                            </button>
                            <a @click="skipOnboarding(2)" class="m-t-20 f-semi f-12 f-c-blue"
                                >Saya Ingin Keluar Dari Mode Panduan</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FilterSorting from "@/component-items/FilterSorting";
import SOLoadMoreLoading from '@/so-components/global/ui/SOLoadMoreLoading.vue';

export default {
    name: "Layanan",
    props: ["setidoutletsetservice"],
    components: { FilterSorting, SOLoadMoreLoading },
    data() {
        return {
            myVarLoopingFunc: "",
            layanan: [],
            layanansearch: [],
            outlet: {},
            idlayanan: "",
            searchKey: "",
            fileImport: "",
            progressloadingimpor: 0,
            leght_data: 0,
            url_import_template: this.$template_import_layanan_url,
            durasi_penyelesaian_hari: "",
            durasi_penyelesaian_jam: "",
            namalayanan: "",
            isClicked: false,
            idoutlet: this.setidoutletsetservice,
            requestHeaders: {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            },
            ekspor: {
                onprogress: false,
                progress_looping: 0,
                lenght: 0,
                exportlink: "",
                timer: null,
            },

            layananPagination: {
                limit: 20,
                offset: 0,
                length: 0,
                pageNumber: 0,
                sortBy: "nama_layanan",
                orderBy: "ASC",
            },
            layananSearchPagination: {
                limit: 20,
                offset: 0,
                length: 0,
                pageNumber: 0,
                sortBy: "nama_layanan",
                orderBy: "ASC",
                key: "",
            },
            listLayananCalled: false,
            listPaketDeposit: [],
            totalPaketDp:0,
			loadingMoreLayanan: false
        };
    },
    mounted() {
        this.idoutlet = this.$route.params.idoutlet;
        $(".showPageSearch").hide();
        $("#errordeletemodal").modal("hide");
		
        $("body").on("DOMSubtreeModified", "#listlayanan", () => {
            if (!this.listLayananCalled) {
                this.listLayananCalled = true;
                this.scroll();
                // this.smartTrackingView("list_layanan_reguler",{"idoutlet":this.idoutlet});

            }
        });


    },
    methods: {
        loadDropUp() {
            $("body").on("hide.bs.dropdown", function(e) {
                if (e.clickEvent) {
                    e.preventDefault();
                }
            });
        },
        cekOnboardingLayanan() {
            if (
                localStorage.getItem("step_walkthrough") != undefined &&
                localStorage.getItem("step_walkthrough") != null &&
                localStorage.getItem("step_walkthrough") == "1"
            ) {
                $(".offanimation").addClass("animated pulse infinite");
                this.loadDropUp();
                this.onboardingLayanan();
            } else if (
                localStorage.getItem("step_walkthrough") != undefined &&
                localStorage.getItem("step_walkthrough") != null &&
                localStorage.getItem("step_walkthrough") == "2"
            ) {
                $(".onboarding-karyawan").addClass("animated pulse infinite");
                this.onboardingKaryawan();
            }
        },
        onDropdownHide(bvEvent) {
            bvEvent.preventDefault();
        },
        onboardingLayanan() {
            var self = this;
            const tour = new Shepherd.Tour({
                defaultStepOptions: {
                    scrollTo: {
                        behavior: "smooth",
                        block: "center",
                    },
                    beforeShowPromise: function() {
                        return new Promise(function(resolve) {
                            setTimeout(function() {
                                resolve();
                            }, 100);
                        });
                    },
                },
                useModalOverlay: true,
            });

            tour.addSteps([
                {
                    classes: "",
                    title: "Tambah Data Layanan",
                    text:
                        "<p>Selain menambahkan, Anda dapat melakukan <b>import & export</b> data layanan sesuai template yang disediakan. klik <b>icon tambah</b> untuk menambahkan data layanan</p><div>Silahkan klik tombol + untuk menambahkan</div>",
                    attachTo: {
                        element: ".flying-button",
                        on: "top",
                    },
                    advanceOn: {
                        selector: ".flying-button",
                        event: "click",
                    },
                },
                {
                    classes: "",
                    title: "Layanan baru",
                    text:
                        "<p>Anda perlu <b>setidaknya menambahkan 2 layanan baru</b> agar outlet Anda siap beroperasi di sistem smartlink. </p>",
                    attachTo: {
                        element: ".tambah-layanan-onboarding",
                        on: "top",
                    },
                    advanceOn: {
                        selector: ".tambah-layanan-onboarding",
                        event: "click",
                    },
                    buttons: [
                        {
                            classes: "shp-btn-left",
                            secondary: true,
                            text: "Lewati",
                            action() {
                                return self.showModalLewatiPanduanLayanan(tour);
                            },
                        },
                    ],
                },
            ]);

            tour.start();
        },
        onboardingLayananContinue() {
            var self = this;
            const tourNext = new Shepherd.Tour({
                defaultStepOptions: {
                    scrollTo: {
                        behavior: "smooth",
                        block: "center",
                    },
                    // beforeShowPromise: function () {
                    //     return new Promise(function (resolve) {
                    //         setTimeout(function () {
                    //             resolve();
                    //         }, 700)
                    //     });
                    // }
                },
                useModalOverlay: true,
            });

            tourNext.addSteps([
                {
                    classes: "",
                    title: "Layanan baru",
                    text:
                        "<p>Anda perlu <b>setidaknya menambahkan 2 layanan baru</b> agar outlet Anda siap beroperasi di sistem smartlink. </p>",
                    attachTo: {
                        element: ".tambah-layanan-onboarding",
                        on: "top",
                    },
                    advanceOn: {
                        selector: ".tambah-layanan-onboarding",
                        event: "click",
                    },
                    buttons: [
                        {
                            classes: "shp-btn-left",
                            secondary: true,
                            text: "Lewati",
                            action() {
                                return self.showModalLewatiPanduanLayanan(tourNext);
                            },
                        },
                    ],
                },
            ]);

            tourNext.start();
        },
        showModalLewatiPanduanLayanan(tourNext) {
            tourNext.cancel();
            $("#modal-lewati-panduan-layanan").modal({ backdrop: "static", keyboard: false });
        },
        onboardingKaryawan() {
            var self = this;
            $(".onboarding-karyawan").addClass("animated pulse infinite");
            const tourKaryawan = new Shepherd.Tour({
                defaultStepOptions: {
                    scrollTo: {
                        behavior: "smooth",
                        block: "center",
                    },
                    // beforeShowPromise: function () {
                    //     return new Promise(function (resolve) {
                    //         setTimeout(function () {
                    //             resolve();
                    //         }, 700)
                    //     });
                    // }
                },
                useModalOverlay: true,
            });

            tourKaryawan.addSteps([
                {
                    classes: "figure fig-clock",
                    title: "Selangkah lebih dekat!",
                    text:
                        "<p>Anda akan <b>segera siap</b> menggunakan sistem smartlink. Mari lanjutkan panduan untuk <b>menyiapkan data karyawan</b></p>",
                    buttons: [
                        {
                            classes: "shp-btn-left",
                            secondary: true,
                            text: "Lewati",
                            action() {
                                return self.showModalLewatiPanduan(tourKaryawan);
                            },
                        },
                        {
                            classes: "shp-btn-right",
                            text: "Ok, Lanjut",
                            action() {
                                return tourKaryawan.next();
                            },
                        },
                    ],
                },
                {
                    classes: "",
                    title: "Tambah Data Karyawan",
                    text:
                        "<p>Klik <b>menu karyawan</b> untuk <b>menambahkan, mengubah atau menghapus</b> data karyawan anda</p>",
                    attachTo: {
                        element: ".onboarding-karyawan",
                        on: "top",
                    },
                    advanceOn: {
                        selector: ".onboarding-karyawan",
                        event: "click",
                    },
                    buttons: [
                        {
                            classes: "shp-btn-left",
                            secondary: true,
                            text: "Lewati",
                            action() {
                                return self.showModalLewatiPanduan(tourKaryawan);
                            },
                        },
                    ],
                },
            ]);

            tourKaryawan.start();
        },
        showModalLewatiPanduan(tourKaryawan) {
            tourKaryawan.cancel();
            $("#modal-lewati-panduan-karyawan").modal({ backdrop: "static", keyboard: false });
        },
        scroll() {
            window.onscroll = () => {
                if ($("#loadingSpinnerLayanan").is(":hidden")) {
                    if ($(".showPageDefault").is(":visible")) {
                        if (
                            this.layananPagination.pageNumber <=
                            Math.ceil(this.layananPagination.length / this.layananPagination.limit)
                        ) {
                            if (
                                Math.floor($(window).scrollTop()) > 0 &&
                                Math.floor($(window).scrollTop()) >=
                                    Math.floor($(document).height() - $(window).height()) - 100
                            ) {
                                this.layananPagination.offset =
                                    this.layananPagination.pageNumber * this.layananPagination.limit;
                                if (this.layananPagination.offset > 0) {
                                    this.listlayanan();
                                }
                                $("#loadingSpinnerLayanan").show();
                            }
                        }
                    }
                }

                if ($("#loadingSpinnerLayananSearch").is(":hidden")) {
                    if ($(".showPageSearch").is(":visible")) {
                        if (
                            this.layananSearchPagination.pageNumber <=
                            Math.ceil(this.layananSearchPagination.length / this.layananSearchPagination.limit)
                        ) {
                            if (
                                Math.floor($(window).scrollTop()) > 0 &&
                                Math.floor($(window).scrollTop()) >=
                                    Math.floor($(document).height() - $(window).height()) - 100
                            ) {
                                this.layananSearchPagination.offset =
                                    this.layananSearchPagination.pageNumber * this.layananSearchPagination.limit;
                                this.SearchFunc();
                                $("#loadingSpinnerLayananSearch").show();
                            }
                        }
                    }
                }
            };
        },
        back() {
            if (this.ekspor.onprogress === 1) {
                return;
            }
            this.listLayananCalled = false;
            this.layananPagination = {
                limit: 20,
                offset: 0,
                length: 0,
                pageNumber: 0,
                sortBy: "nama_layanan",
                orderBy: "ASC",
            };
            this.layananSearchPagination = {
                limit: 20,
                offset: 0,
                length: 0,
                pageNumber: 0,
                sortBy: "nama_layanan",
                orderBy: "ASC",
                key: "",
            };
            this.$emit("isdetailsetservice");
        },
        tambahlayanan() {
            $(".offanimation").removeClass("animated pulse infinite");
            this.$emit("gocreateservice");
            this.smartTrackingClick("add_layanan_reguler",{"idoutlet":this.idoutlet});

        },
        edit(idlayanan) {
            this.$emit("goeditlayanan", idlayanan);
            this.smartTrackingClick("edit_layanan_reguler",{"idoutlet":this.idoutlet});
        },
        closeErrorModal() {
          this.listPaketDeposit=[];
          this.totalPaketDp=0;
          $("#errordeletemodal").modal("hide");
        },
        edits(idlayanan) {
            this.$emit("goeditlayanan", idlayanan);
            this.closesearch();
        },
        showmodaldel(l) {
            this.idlayanan = l.idlayanan;
            this.namalayanan = l.nama_layanan;
            $("#deletemodal").modal("show");
        },
        showmodaldels(ls) {
            this.idlayanan = ls.idlayanan;
            this.namalayanan = ls.nama_layanan;
            $("#deletemodal").modal("show");
        },
        async exportLayananBackground(tryAgain = "") {
            this.ekspor.onprogress = 1;

            try {
                const response = await this.$axios.get(
                    this.$baseurl + "/masterData/layanan/export_layanan_excel?idoutlet=" + this.setidoutletsetservice,
                    this.requestHeaders
                );
                if (response.status === 200) {
                    if (response.data.status === true) {
                        let that = this;
                        this.ekspor.timer = setInterval(function() {
                            that.checkExportLayananBackground(that);
                        }, 1000);
                        // this.deleteStorage(filenameStorage);
                    } else {
                        this.ekspor.onprogress = 0;
                    }
                }
            } catch (e) {
                this.ekspor.onprogress = 0;

                if (tryAgain !== "yes") {
                    this.exportLayananBackground("yes");
                } else {
                    this.$catch_error_response(e);
                }
            }
        },
        async checkExportLayananBackground(that) {
            try {
                const response = await this.$axios.get(
                    this.$baseurl + "/masterData/layanan/track_export_layanan?idoutlet=" + this.setidoutletsetservice,
                    this.requestHeaders
                );
                if (response.status === 200) {
                    if (response.data.status === true) {
                        var dataprogress = response.data.data;
                        that.ekspor.progress_looping = dataprogress.progress_looping;
                        that.ekspor.lenght = dataprogress.lenght_data;

                        if (dataprogress.status_progress === "1") {
                            window.clearInterval(that.ekspor.timer);
                            var filenameStorage = response.data.data.filename;
                            var linkStorage = response.data.data.link_url;
                            linkStorage = linkStorage.replace(filenameStorage, encodeURIComponent(filenameStorage));
                            // window.open(linkStorage, "_blank");
                            that.ekspor.exportlink = linkStorage;
                            const flutterConfig = JSON.parse(localStorage.getItem('flutterConfig'))
                            setTimeout(function() {
                                if (that.isWebview() && flutterConfig.platform !== 'web') {
                                    that.flutterDownload(that.ekspor.exportlink);
                                } else {
                                    that.$refs.eksporlink.click();
                                }
                                setTimeout(function() {
                                    that.ekspor.onprogress = 0;
                                    that.deleteStorage(filenameStorage);
                                }, 3000);
                            }, 1000);
                        }

                        // that.$forceUpdate()
                    } else {
                        this.$toast.error(response.data.msg);
                    }
                }
            } catch (e) {
                this.$catch_error_response(e);
            }
        },

        async exportLayanan() {
            try {
                $("#loadingPageExportLayanan").show();
                $("#listlayanan").hide();
                const response = await this.$axios.get(
                    this.$baseurl + "/masterData/layanan/direct_export_layanan?idoutlet=" + this.setidoutletsetservice,
                    this.requestHeaders
                );
                if (response.status === 200) {
                    if (response.data.status === true) {
                        var filenameStorage = response.data.data.filename;
                        var linkStorage = response.data.data.link_file_storage;
                        linkStorage = linkStorage.replace(filenameStorage, encodeURIComponent(filenameStorage));

                        window.open(linkStorage, "_blank");
                        var that = this;
                        setTimeout(function() {
                            that.deleteStorage(encodeURIComponent(filenameStorage));
                        }, 3000);
                        $("#loadingPageExportLayanan").hide();
                        $("#listlayanan").show();
                    } else {
                        this.$toast.error(response.data.msg);
                        $("#loadingPageExportLayanan").hide();
                        $("#listlayanan").show();
                    }
                }
            } catch (e) {
                this.$catch_error_response(e);
                $("#loadingPage").hide();
                $("#loadingPage").removeClass("overlayLoading");
                $("#loadingPageExportLayanan").hide();
                $("#listlayanan").show();
            }
        },
        async skipOnboarding(params) {
            $("#loadingPage").show();
            $("#loadingPage").addClass("overlayLoading");
            $("#modal-lewati-panduan").modal("hide");
            $("#modal-lewati-panduan-layanan").modal("hide");
            $("#modal-lewati-panduan-karyawan").modal("hide");
            $(".offanimation").removeClass("animated pulse infinite");
            try {
                const datawalkthrough = new FormData();
                datawalkthrough.append("walkthrough", params);
                const response = await this.$axios.post(
                    this.$baseurl + "/masterData/owner/update_status_walkthrough",
                    datawalkthrough,
                    this.requestHeaders
                );
                if (response.data.code === 200) {
                    if (response.data.status === true) {
                        $("#loadingPage").hide();
                        $("#loadingPage").removeClass("overlayLoading");
                        localStorage.setItem("step_walkthrough", params);
                    }
                } else {
                    $("#loadingPage").hide();
                    $("#loadingPage").removeClass("overlayLoading");
                    this.popupType = "error";
                    this.popupMessage = response.data.msg;
                }
            } catch (e) {
                if (!e.code) {
                    $("#loadingPage").hide();
                    $("#loadingPage").removeClass("overlayLoading");
                    this.popupType = "error";
                    this.popupErrorException = e;
                }
            }
        },
        async deleteStorage(filename) {
            try {
                const response = await this.$axios.post(
                    this.$baseurl + "/masterData/layanan/delete_file_export_layanan?filename=" + filename,
                    null,
                    this.requestHeaders
                );
            } catch (e) {
                this.$catch_error_response(e);
                $("#loadingPage").hide();
                $("#loadingPage").removeClass("overlayLoading");
            }
        },
        async cekconnection() {
            $("#loadingPage").addClass("overlayLoading");
            this.isClicked = true;
            try {
                const response = await this.$axios.get(
                    this.$baseurl + "/masterData/meta/cek_koneksi",
                    this.requestHeaders
                );
                if (response.status === 200) {
                    if (response.data.status === true) {
                        try {
                            window.open(this.url_import_template, "_blank");
                            this.flutterDownload(this.url_import_template)
                        } catch (error) {
                            this.$toast.error(error);
                        }
                        $("#loadingPage").removeClass("overlayLoading");
                        this.isClicked = false;
                    } else {
                        $("#loadingPage").removeClass("overlayLoading");
                        this.isClicked = false;
                        this.$toast.error(response.data.msg);
                    }
                }
            } catch (e) {
                this.$catch_error_response(e);
                $("#loadingPage").hide();
                $("#loadingPage").removeClass("overlayLoading");
            }
        },

        async importdata() {
            $("#loadingPageImportLayanan").addClass("overlayLoading");
            $("#loadingPageImportLayanan").addClass("show-import");
            this.fileImport = this.$refs.file.files[0];
            try {
                const updatedata = new FormData();
                updatedata.append("fileExcel", this.fileImport);
                const response = await this.$axios.post(
                    this.$baseurl +
                        "/masterData/layanan/import_layanan_excel_revise?idoutlet=" +
                        this.setidoutletsetservice,
                    updatedata,
                    this.requestHeaders
                );
                if (response.status === 200) {
                    if (response.data.status === true) {
                        $("#impormodal").modal("hide");
                        this.trackImportdata();
                        this.myVarLoopingFunc = setInterval(() => {
                            this.trackImportdata();
                        }, 5000);
                    } else {
                        $("#loadingPageImportLayanan").removeClass("overlayLoading");
                        $("#loadingPageImportLayanan").removeClass("show-import");
                        this.$toast.error("Nama file atau extensi file yang anda unggah salah!");
                    }
                }
            } catch (e) {
                this.$catch_error_response(e);
                $("#loadingPageImportLayanan").removeClass("overlayLoading");
                $("#loadingPageImportLayanan").removeClass("show-import");
                $("#impormodal").modal("hide");

                this.isClicked2 = false;
                $("#textBtnother").show();
                $("#anotherButton").prop("disabled", false);
            }
        },

        async trackImportdata() {
            this.fileImport = this.$refs.file.files[0];
            $("#importLayanan").val("");
            try {
                const updatedata = new FormData();
                updatedata.append("fileExcel", this.fileImport);
                const response = await this.$axios.get(
                    this.$baseurl + "/masterData/layanan/track_import_layanan?idoutlet=" + this.setidoutletsetservice,
                    this.requestHeaders
                );
                this.fileImport = "";
                if (response.status === 200) {
                    if (response.data.status === true) {
                        if (response.data.data.status_progress === "0") {
                            var length = parseInt(response.data.data.lenght_data);
                            var progress = parseInt(response.data.data.progress_looping);
                            var getPercen = (progress / length) * 100;
                            var oldData = $("#dataCOunterLayanan").text();
                            $("#dataCOunterLayanan").text(getPercen.toFixed(2));
                            // this.counter(oldData)
                            // $("#dataCOunterLayanan").text(oldData)
                        } else if (response.data.data.status_progress === "1") {
                            clearInterval(this.myVarLoopingFunc);
                            // clearInterval(this.myVarLoopingFunc);
                            $("#loadingPageImportLayanan").removeClass("overlayLoading");
                            $("#loadingPageImportLayanan").removeClass("show-import");
                            this.listlayanan();
                            var length = parseInt(response.data.data.lenght_data);
                            var progress = parseInt(response.data.data.progress_looping);
                            var getPercen = (progress / length) * 100;
                            var oldData = $("#dataCOunterLayanan").text();
                            $("#dataCOunterLayanan").text(getPercen.toFixed(2));
                            // this.counter(oldData)
                            // $("#dataCOunterLayanan").text(oldData)
                            // $("#dataCOunterLayanan").text(0)
                            this.$toast.success(response.data.data.msg_progress);
                        } else if (response.data.data.status_progress === "2") {
                            $("#loadingPageImportLayanan").removeClass("overlayLoading");
                            $("#loadingPageImportLayanan").removeClass("show-import");
                            clearInterval(this.myVarLoopingFunc);
                            this.listlayanan();
                            $("#dataCOunterLayanan").text(0);
                            this.$toast.error(response.data.data.msg_progress);
                        }
                    } else {
                        $("#dataCOunterLayanan").text(0);
                        if (response.data.data.status_progress === "3") {
                            $("#loadingPageImportLayanan").removeClass("overlayLoading");
                            $("#loadingPageImportLayanan").removeClass("show-import");
                            clearInterval(this.myVarLoopingFunc);
                            this.$toast.error(response.data.data.msg_progress);
                        }
                    }
                }
            } catch (e) {
                this.$catch_error_response(e);
                clearInterval(this.myVarLoopingFunc);
                $("#loadingPageImportLayanan").removeClass("overlayLoading");
                $("#loadingPageImportLayanan").removeClass("show-import");

                this.isClicked2 = false;
                $("#textBtnother").show();
                $("#anotherButton").prop("disabled", false);
            }
        },
        counter(args) {
            $(".count")
                .prop("Counter", 0)
                .animate(
                    {
                        Counter: $(".count").text(),
                    },
                    {
                        duration: 5000,
                        easing: "swing",
                        step: function(now) {
                            var data = Math.ceil(now);
                            if (now >= args) {
                                $(".count").text(data);
                            }
                            if (data == 100) {
                                setTimeout(() => {
                                    $("#loadingPageImportLayanan").removeClass("overlayLoading");
                                    $("#loadingPageImportLayanan").removeClass("show-import");
                                }, 4000);
                            }
                        },
                    }
                );
        },

        newrupiah(angka, prefix) {
            /* Fungsi formatRupiah */
            var number_string = angka.replace(/[^.\d]/g, "").toString(),
                split = number_string.split("."),
                sisa = split[0].length % 3,
                rupiah = split[0].substr(0, sisa),
                ribuan = split[0].substr(sisa).match(/\d{3}/gi);
            // tambahkan titik jika yang di input sudah menjadi angka ribuan
            if (ribuan) {
                var separator = sisa ? "." : "";
                rupiah += separator + ribuan.join(".");
            }

            rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
            return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
        },

        async listlayanan(reset) {
            if (reset !== undefined) {
                this.layananPagination = {
					limit: 20,
					offset: 0,
					length: 0,
					pageNumber: 0,
					sortBy: "nama_layanan",
					orderBy: "ASC",
				}
            }
            if (this.layananPagination.offset === 0) {
                this.layanan = [];
                $("#loadingPage").show();
                $("#loadingPage").addClass("overlayLoading");
                this.smartTrackingView("list_layanan_reguler",{"idoutlet":this.idoutlet});

            }
            var sort_get;
            var order_get;
            try {
                sort_get = this.layananPagination.sortBy;
                order_get = this.layananPagination.orderBy;
				this.loadingMoreLayanan = true
                const response = await this.$axios.get(
                    this.$baseurl +
                        "/masterData/meta/list_layanandefault_meta?idoutlet=" +
                        this.setidoutletsetservice +
                        "&order_by=" +
                        order_get +
                        "&sort_by=" +
                        sort_get +
                        "&limit=" +
                        this.layananPagination.limit +
                        "&offset=" +
                        this.layananPagination.offset,
                    this.requestHeaders
                );
                if (response.status === 200) {
                    if (response.data.status === true) {
                        this.convertMiliseconds();
                        var data = response.data.data;
                        this.leght_data = response.data.lenght_data;
                        this.layananPagination.length += data.length;
                        for (var i = 0; i < data.length; i++) {
                            var nominal = data[i].harga;
                            var toRp = this.newrupiah(nominal.toString());
                            this.layanan.push({
                                nama_layanan: data[i].layanan.nama_layanan,
                                idlayanan: data[i].layanan_idlayanan,
                                satuan: data[i].layanan.satuan.nama,
                                harga: toRp,
                                min_depo: data[i].min_order_depo,
                                min_reg: data[i].min_order_reg,
                                mesin: data[i].snap,
                                durasi_penyelesaian_hari: this.convertMiliseconds(data[i].layanan.durasi_penyelesaian),
                                durasi_penyelesaian_jam: this.sisaJam(data[i].layanan.durasi_penyelesaian),
                            });
                        }
                        $("#loadingPage").removeClass("overlayLoading");
                        $("#loadingPage").hide();
                        if (response.data.data.length > 0) {
                            $("#iconsearch").show();
                        } else {
                            if (this.layananPagination.offset > 0) {
                                $("#iconsearch").show();
                            } else {
                                $("#iconsearch").hide();
                            }
                        }
                        this.layananPagination.pageNumber++;
                        $("#loadingSpinnerLayanan").hide();
                    }
                }
				this.loadingMoreLayanan = false
            } catch (e) {
				this.loadingMoreLayanan = false
                this.$catch_error_response(e);
                $("#loadingSpinnerLayanan").hide();

                $("#loadingPage").hide();
                $("#loadingPage").removeClass("overlayLoading");
            }
        },

        convertMiliseconds(miliseconds) {
            var days, hours, minutes, seconds, total_hours, total_minutes, total_seconds;

            total_seconds = parseInt(Math.floor(miliseconds / 1000));
            total_minutes = parseInt(Math.floor(total_seconds / 60));
            total_hours = parseInt(Math.floor(total_minutes / 60));
            days = parseInt(Math.floor(total_hours / 24));

            seconds = parseInt(total_seconds % 60);
            minutes = parseInt(total_minutes % 60);
            hours = parseInt(total_hours % 24);

            return days;
        },
        sisaJam(miliseconds) {
            var days, hours, sisa_jam, total_hours, total_minutes, total_seconds;

            total_seconds = parseInt(Math.floor(miliseconds / 1000));
            total_minutes = parseInt(Math.floor(total_seconds / 60));
            total_hours = parseInt(Math.floor(total_minutes / 60));
            days = parseInt(Math.floor(total_hours / 24));
            sisa_jam = parseInt(Math.floor(total_hours % 24));
            return sisa_jam;
        },
        async detailoutlet() {
            try {
                const response = await this.$axios.get(
                    this.$baseurl + "/masterData/meta/detail_outlet_meta?idoutlet=" + this.setidoutletsetservice,
                    this.requestHeaders
                );
                this.outlet = response.data.data[0];
            } catch (e) {
                this.$catch_error_response(e);
                $("#loadingPage").hide();
                $("#loadingPage").removeClass("overlayLoading");
            }
        },
        async deletelayanan() {
            $("#loadingPage").show();
            $("#loadingPage").addClass("overlayLoading");
            try {
                const dellayanan = new FormData();
                const response = await this.$axios.post(
                    this.$baseurl + "/masterData/layanan/delete_layanan_v2?idlayanan=" + this.idlayanan,
                    dellayanan,
                    this.requestHeaders
                );
                if (response.data.status === true) {
                    this.listlayanan(true);
                    this.$toast.success(response.data.msg);
                } else {
                    $("#loadingPage").hide();
                    $("#loadingPage").removeClass("overlayLoading");
                    let listPaket = response.data.data.data_deposit
                    this.totalPaketDp = listPaket.length;
                    listPaket.forEach((dp, idx) => {
                      if (idx < 4) {
                        this.listPaketDeposit.push(dp)
                      }
                    });
                    $("#errordeletemodal").modal("show");
                }
            } catch (e) {
                this.$catch_error_response(e);
                $("#loadingPage").hide();
                $("#loadingPage").removeClass("overlayLoading");
            }
        },
        async sortingLayanan(key) {
            $("#cardWorkshop").hide();
            $("#spinnerWorkshop").prop("style", "display:inline-block");
            switch (key) {
                case "asc":
                    $("#dropdownMenuButton2").text("Urut Dari A - Z ");
                    this.getsortingLayanan(1);
                    break;
                case "desc":
                    $("#dropdownMenuButton2").text("Urut Dari Z - A ");
                    this.getsortingLayanan(2);
                    break;
                case "terbaru":
                    $("#dropdownMenuButton2").text("Urut Dari Terbaru ");
                    this.getsortingLayanan(3);
                    break;
                case "terlama":
                    $("#dropdownMenuButton2").text("Urut Dari Terlama ");
                    this.getsortingLayanan(4);
                    break;
                default:
                    $("#dropdownMenuButton2").text("Urutkan ");
            }
        },
        async getsortingLayanan(datasortingLayanan) {
            var sort_by;
            var order_by;
            $("#loadingPage").show();
            $("#loadingPage").addClass("overlayLoading");
            try {
                if (datasortingLayanan === 1) {
                    sort_by = "nama_layanan";
                    order_by = "ASC";
                } else if (datasortingLayanan === 2) {
                    sort_by = "nama_layanan";
                    order_by = "DESC";
                } else if (datasortingLayanan === 3) {
                    sort_by = "created_at";
                    order_by = "DESC";
                } else if (datasortingLayanan === 4) {
                    sort_by = "created_at";
                    order_by = "ASC";
                } else {
                    return;
                }
                const response = await this.$axios.get(
                    this.$baseurl +
                        "/masterData/meta/list_layanandefault_meta?idoutlet=" +
                        this.setidoutletsetservice +
                        "&order_by=" +
                        order_by +
                        "&sort_by=" +
                        sort_by,
                    this.requestHeaders
                );
                if (response.status === 200) {
                    if (response.data.status === true) {
                        this.layanan = [];
                        this.convertMiliseconds();
                        var data = response.data.data;
                        for (var i = 0; i < data.length; i++) {
                            this.layanan.push({
                                nama_layanan: data[i].layanan.nama_layanan,
                                idlayanan: data[i].layanan_idlayanan,
                                satuan: data[i].layanan.satuan.nama,
                                harga: data[i].harga,
                                min_depo: data[i].min_order_depo,
                                min_reg: data[i].min_order_reg,
                                mesin: data[i].snap,
                                durasi_penyelesaian_hari: this.convertMiliseconds(data[i].layanan.durasi_penyelesaian),
                                durasi_penyelesaian_jam: this.sisaJam(data[i].layanan.durasi_penyelesaian),
                            });
                        }
                    }
                }
                $("#loadingPage").hide();
                $("#loadingPage").removeClass("overlayLoading");
            } catch (e) {
                this.$catch_error_response(e);
                $("#loadingPage").hide();
                $("#loadingPage").removeClass("overlayLoading");
            }
        },
        showsearch() {
            $(".showPageSearch").show();
            $("#textTop").text("Minimal 2 karakter");
            $(".showPageSearch").addClass("animated slideInDown");
            $(".showPageDefault").hide();
            $("#input_search_Layanan").focus();
        },
        closesearch() {
            $(".showPageSearch").removeClass("animated slideInDown");
            $(".showPageSearch").hide();
            $(".showPageDefault").show();
            this.layanansearch = [];
            this.searchKey = "";
            $("#textTop").text("Minimal 2 karakter");

            this.layananSearchPagination = {
                limit: 20,
                offset: 0,
                length: 0,
                pageNumber: 0,
                sortBy: "nama_layanan",
                orderBy: "ASC",
                key: "",
            };
        },
        searchDeposit() {
            $("#textTop").text("Minimal 2 karakter");
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.layanansearch = [];
                $(".spinner").prop("style", "display:inline-block");
                this.SearchFunc();
            }, 500);
        },
        async SearchFunc() {
            var key = this.searchKey;
            if (this.layananSearchPagination.offset === 0 || this.layananSearchPagination.key !== key) {
                this.layanansearch = [];
                $("#textTop").text("Sedang mencari...");
                this.layananSearchPagination = {
                    limit: 20,
                    offset: 0,
                    length: 0,
                    pageNumber: 0,
                    sortBy: "created_at",
                    orderBy: "DESC",
                    key: key,
                };
            }
            if (key.length >= 2) {
                try {
                    const response = await this.$axios.get(
                        this.$baseurl +
                            "/masterData/meta/list_layanandefault_meta?idoutlet=" +
                            this.setidoutletsetservice +
                            "&key=" +
                            key +
                            "&limit=" +
                            this.layananSearchPagination.limit +
                            "&offset=" +
                            this.layananSearchPagination.offset,
                        this.requestHeaders
                    );
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.layananSearchPagination.length += response.data.data.length;
                            if (response.data.data.length > 0) {
                                $("#textTop").text(
                                    "Ditemukan " + response.data.data.length + " layanan dengan kata '" + key + "'"
                                );
                                this.convertMiliseconds();
                                var data = response.data.data;
                                for (var i = 0; i < response.data.data.length; i++) {
                                    this.layanansearch.push({
                                        nama_layanan: data[i].layanan.nama_layanan,
                                        idlayanan: data[i].layanan_idlayanan,
                                        satuan: data[i].layanan.satuan.nama,
                                        harga: data[i].harga,
                                        min_depo: data[i].min_order_depo,
                                        min_reg: data[i].min_order_reg,
                                        mesin: data[i].snap,
                                        durasi_penyelesaian_hari: this.convertMiliseconds(
                                            data[i].layanan.durasi_penyelesaian
                                        ),
                                        durasi_penyelesaian_jam: this.sisaJam(data[i].layanan.durasi_penyelesaian),
                                    });
                                }
                            } else {
                                if (this.layananSearchPagination.offset === 0) {
                                    $("#textTop").text("Tidak menemukan '" + key + "'");
                                }
                            }
                            this.layananSearchPagination.pageNumber++;
                            $(".spinner").prop("style", "display:none");

                            $("#loadingSpinnerLayananSearch").hide();
                        }
                    }
                } catch (e) {
                    this.$catch_error_response(e);
                    $("#loadingSpinnerLayananSearch").hide();
                    $(".spinner").prop("style", "display:none");

                    $("#loadingPage").hide();
                    $("#loadingPage").removeClass("overlayLoading");
                }
            } else {
                this.layanansearch = [];
                $(".spinner").prop("style", "display:none");
                $("#textTop").text("Minimal 3 karakter");
            }
        },
        filter(payload) {
            this.layananPagination = payload.data;
            this.listlayanan();
            $("#dropdownMenuButton-" + payload.type).html(payload.textSorting);
        },
		loadMoreListLayanan() {
			this.layananPagination.offset = this.layananPagination.pageNumber * this.layananPagination.limit;
			this.listlayanan();
		}
    },
};
</script>

<style scoped>
.info-snap{
  margin-right: -20%;
  background-color: #EDEDED;
  padding: 2px 4px;
  border-radius: 3px;
}
.image.text-alignC {
    margin-top: 185px;
}

#loadingPageImportLayanan {
    display: none;
}

#loadingPageExportLayanan {
    display: none;
}

.fullpageLoading {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.card-2 {
    margin-top: 20px;
    margin-bottom: 20px;
}

.div-impor {
    background: #f2f2f2;
    border-radius: 3px;
    padding: 11px 12px;
}

.line-patah {
}

.atribute > input {
    display: none;
}

.atribute img {
    cursor: pointer;
}

@media (max-width: 610px) {
    .pointer {
        right: 20%;
    }
}

@media (max-width: 420px) {
    .pointer {
        right: 5%;
    }
}

.show-import {
    display: block !important;
}

.desciption-txt-modal {
    letter-spacing: -0.02em;
    line-height: 140%;
    color: #333333;
}

.nomore {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>
